import { UnexpectedError } from "../../domain/errors";
import { DuplicatedNfError } from "../../domain/errors/duplicated-nf-error";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { NormalizedCargo } from "../../domain/models/cargo-model";
import { OverwriteCargo } from "../../domain/usecases/overwrite-cargo";
import { AddCargoResult, SaveCargo } from "../../domain/usecases/save-cargo";
import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbOverwriteCargo implements OverwriteCargo {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async overwrite(params: OverwriteCargo.Params): Promise<{ id: string }> {
    const res = await this.httpClient.request({
      url: this.url,
      method: "post",
      body: params,
    });

    switch (res.statusCode) {
      case HttpStatusCode.ok:
        return res.body;
      case HttpStatusCode.forbidden:
        throw new DuplicatedNfError(res.body.error.data);
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();
      default:
        throw new UnexpectedError();
    }
  }
}
